// GERADO POR scripts/build-icons.js — não edite à mão.
// Fonte: handoff/assets/icons/ball.svg

import React from 'react';

/** Proporção nativa 24x24. */
export default function IconeBall({ size = 24, color = 'currentColor', strokeWidth, className, title, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth ?? 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20"></path><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path>
    </svg>
  );
}
